import type { LibraryData } from '@/core/types/library.type'

/** Fully qualified type names defined in the library UGM (TYPE_DEF entries). */
export function buildHostedTypeFqns(libraryData: LibraryData): Set<string> {
  const fqns = new Set<string>()

  for (const classData of Object.values(libraryData.classes ?? {})) {
    const name = classData.name?.trim()
    if (!name) continue

    const namespace = classData.namespace?.trim()
    if (namespace && namespace !== '.') {
      fqns.add(`${namespace}.${name}`)
    } else {
      fqns.add(name)
    }
  }

  return fqns
}
